import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@material-ui/core/styles";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import Service from "./Service.jsx";
import "core-js";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export default class ServiceDialog extends React.Component {
  /**
   * The dialog width has been set to occupy the full width of browser through the `contentStyle` property.
   */
  state = {
    open: false,
    serviceJson: this.props.serviceJson,
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  restoreJson = () => {
    window.top.ivrJson = this.state.serviceJson;
    window.top.ivrJson.moduleGroupId = Number(this.props.serviceId);
    window.top.serviceRestore(this.props.isLiveVersion);
    this.handleClose();
  };

  setStateJson = (serviceJson) => {
    const { serviceId } = this.props;
    const updatedServiceJson = { ...serviceJson, moduleGroupId: serviceId };
    this.setState({ serviceJson: updatedServiceJson });
  };

  componentDidMount = () => {};

  render() {
    const title = <h1>Service Restore</h1>;

    const now = new Date();
    const timestamp = `${`0${now.getDate()}`.slice(-2)} ${months[now.getMonth()]} ${now.getFullYear()}
                               at ${`0${now.getHours() > 12 ? now.getHours() - 12 : now.getHours()}`.slice(-2)}:${`0${now.getMinutes()}`.slice(-2)} ${now.getHours() > 11 ? "PM" : "AM"}`;

    return (
      <ThemeProvider>
        <div>
          <a
            onClick={this.handleOpen}
            href="#"
            className={`button ${this.props.isLiveVersion ? "liveVersion" : "button-type-2"}`}
            style={{
              textAlign: "center",
              width: this.props.isLiveVersion ? "118px" : "126px",
            }}
          >
            Compare{this.props.isLiveVersion && <br />}
            {this.props.isLiveVersion && "live version"}
          </a>
          <Dialog
            modal={true}
            fullWidth={true}
            maxWidth={"xl"}
            open={this.state.open}
            autoScrollBodyContent={false}
            bodyStyle={{ padding: "inherit" }}
            bodyClassName="restoredialog-body"
            contentClassName="restoredialog-content"
            paperClassName="restoredialog-paper"
          >
            <DialogTitle
              className="title"
              style={{ padding: 0, margin: "-1px 0" }}
            >
              {title}
            </DialogTitle>
            <DialogContent
              style={{ padding: 0 }}
              className={"restoredialog-body"}
            >
              <div className="restoredialog-gridcontainer">
                <div className="restoredialog-griditem restoredialog-griditem-current">
                  <h2 style={{ margin: "8px 0" }}>
                    CURRENT
                    {window.top.ivrJson &&
                    (window.top.ivrJson.serviceUpdated ||
                      // eslint-disable-next-line no-undef
                      isSubServiceUpdated(window.top.ivrJson))
                      ? " (unsaved changes)"
                      : ""}{" "}
                    : {timestamp.toString()}
                  </h2>
                  <Service
                    clientId={this.props.clientId}
                    serviceId={this.props.serviceId}
                    isPreview
                    className="restoredialog-service"
                    style={{ height: "100%" }}
                  />
                </div>
                <div className="restoredialog-griditem restoredialog-griditem-compare">
                  <h2 style={{ margin: "8px 0" }}>
                    RESTORE POINT : {this.props.serviceDate}
                  </h2>
                  <Service
                    clientId={this.props.clientId}
                    serviceId={this.props.serviceId}
                    serviceJson={this.props.serviceJson}
                    serviceVersion={this.props.serviceVersion}
                    onLoadHandler={this.setStateJson}
                    isPreview
                    className="restoredialog-service"
                    style={{ height: "100%" }}
                  />
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <a
                className="button button-type-2"
                href="#"
                onClick={() => this.setState({ open: false })}
                style={{
                  marginRight: "8px",
                  width: "80px",
                  textAlign: "center",
                }}
              >
                CLOSE
              </a>
              {this.state.serviceJson ? (
                <a
                  className="button"
                  href="#"
                  onClick={this.restoreJson}
                  style={{ width: "80px", textAlign: "center" }}
                >
                  RESTORE
                </a>
              ) : (
                <a
                  className="button"
                  href="#"
                  style={{ opacity: "0.5", width: "80px", textAlign: "center" }}
                >
                  RESTORE
                </a>
              )}
            </DialogActions>
          </Dialog>
        </div>
      </ThemeProvider>
    );
  }
}

ServiceDialog.propTypes = {
  serviceJson: PropTypes.obj,
  isLiveVersion: PropTypes.bool,
  serviceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  serviceVersion: PropTypes.string,
  serviceDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
